var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    [
      _c(
        "v-app-bar",
        { attrs: { flat: "", app: "", "clipped-left": "", dense: "" } },
        [
          _c("v-toolbar-title", [
            _c("a", { attrs: { href: "http://acelerex.com" } }, [
              _c("img", {
                staticClass: "mt-2",
                attrs: {
                  height: "60",
                  src: require("@/assets/rex-analytics-logo.svg"),
                },
              }),
            ]),
          ]),
          _c("v-spacer"),
          _vm.isAuthenticated
            ? _c(
                "v-menu",
                {
                  attrs: {
                    bottom: "",
                    "min-width": "200px",
                    rounded: "",
                    "offset-y": "",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function (ref) {
                          var on = ref.on
                          return [
                            _c(
                              "v-btn",
                              _vm._g({ attrs: { icon: "" } }, on),
                              [
                                _c(
                                  "v-avatar",
                                  {
                                    staticClass: "primary white--text",
                                    attrs: { left: "", size: "35" },
                                  },
                                  [
                                    _vm.currentUser.picture
                                      ? _c("img", {
                                          attrs: {
                                            src: _vm.currentUser.picture,
                                          },
                                        })
                                      : _vm._e(),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    3944285955
                  ),
                },
                [
                  _c(
                    "v-card",
                    [
                      _c(
                        "v-list-item-content",
                        { staticClass: "justify-center" },
                        [
                          _c(
                            "div",
                            { staticClass: "mx-auto text-center" },
                            [
                              _c(
                                "v-avatar",
                                {
                                  staticClass: "primary white--text",
                                  attrs: { color: "primary", left: "" },
                                },
                                [
                                  _vm.currentUser.picture
                                    ? _c("img", {
                                        attrs: { src: _vm.currentUser.picture },
                                      })
                                    : _vm._e(),
                                ]
                              ),
                              _c("p", { staticClass: "text-caption mt-1" }, [
                                _vm._v(
                                  " " + _vm._s(_vm.currentUser.email) + " "
                                ),
                              ]),
                              _c("v-divider", { staticClass: "my-3" }),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    depressed: "",
                                    rounded: "",
                                    text: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.logout.apply(null, arguments)
                                    },
                                  },
                                },
                                [
                                  _c("v-icon", [_vm._v("mdi-logout")]),
                                  _vm._v(" Logout "),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "v-main",
        [
          _c(
            "v-container",
            { staticClass: "pt-6 mt-12" },
            [
              _c(
                "v-row",
                { attrs: { justify: "center" } },
                [
                  _c("v-img", {
                    attrs: {
                      src: require("@/assets/gandalf.png"),
                      "max-width": "200",
                    },
                  }),
                  _c(
                    "v-col",
                    { staticClass: "text-center", attrs: { cols: "12" } },
                    [
                      _c("h2", { staticClass: "text-h4 my-4" }, [
                        _vm._v(
                          "You do not have a license to use this software"
                        ),
                      ]),
                      _c("p", [_vm._v("403 Forbidden")]),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            outlined: "",
                            color: "primary",
                            to: "/portal",
                          },
                        },
                        [_vm._v("Go to Acelerex Portal")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-footer",
        { attrs: { app: "", color: "secondary", "max-height": "32px" } },
        [
          _c(
            "v-row",
            { attrs: { justify: "center" } },
            [
              _c(
                "v-col",
                {
                  staticClass: "text-center white--text text-body-2 pt-0",
                  attrs: { cols: "12" },
                },
                [
                  _c("strong", [_vm._v("Dispatcher v" + _vm._s(_vm.version))]),
                  _vm._v(
                    " — ©2017 - " +
                      _vm._s(new Date().getFullYear()) +
                      " Acelerex Inc. "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }